import { render, staticRenderFns } from "./HistoryButtons.vue?vue&type=template&id=08b3ac5c&"
import script from "./HistoryButtons.vue?vue&type=script&lang=ts&"
export * from "./HistoryButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports